import React from 'react'
import PropTypes from 'prop-types'

import Text from './Text'
import { Line } from '@generators/htmlComponents/Line'
import colors from '@settings/styleSettings'

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    padding: 24,
  },
  image: {
    width: '20vw',
    height: '10vh',
    textAlign: 'center',
  },
  name: {
    marginTop: 8,
  },
  line: {
    display: 'block',
    width: '80%',
    marginTop: 8,
  },
}

export const Signature = ({ image, beneficiaryName }) => (
  <div style={styles.container}>
    <img src={image} style={styles.image} alt="assinatura" />
    <div style={styles.line}>
      <Line lineColor={colors.strongGray} />
    </div>
    <Text style={styles.name}>{beneficiaryName}</Text>
  </div>
)

Signature.propTypes = {
  image: PropTypes.string.isRequired,
  beneficiaryName: PropTypes.string.isRequired,
}
